import { SearchField, SearchInput } from "@/components/search-field";
import { usePaginationWithDynamicPageSize } from "@/hooks/usePaginationWithDynamicPageSize";
import { getPageSizeOptions } from "@/utils/getPageSizeOptions";

import { FeaturePageLayout } from "../shared";
import { IssueReportsTable } from "./components/IssuReportsTable";
import { useGetIssueReports } from "./hooks/useGetIssueReports";

export default function IssueReports() {
  const {
    debouncedQuery,
    inputValue,
    itemsPerPage,
    page,
    setInputValue,
    setItemsPerPage,
    setPage,
    setSortDescriptor,
    sortDescriptor,
  } = usePaginationWithDynamicPageSize();

  const direction: "asc" | "desc" =
    sortDescriptor.direction === "descending" ? "desc" : "asc";

  const { data: response, isLoading } = useGetIssueReports({
    direction,
    itemsPerPage,
    page,
    search: debouncedQuery,
    sortBy: sortDescriptor?.column as string,
  });

  return (
    <div className="p-xl">
      <FeaturePageLayout title="Issues Reports">
        <div className="py-5 px-5 bg-bg-primary">
          <div className="w-full bg-bg-primary py-3">
            <SearchField aria-label="Search users" className="w-full">
              <SearchInput
                onChange={(e) => setInputValue(e.target.value)}
                onClear={() => setInputValue("")}
                placeholder="Search..."
                value={inputValue}
              />
            </SearchField>
          </div>
          {response ? (
            <IssueReportsTable
              isLoading={isLoading}
              pagination={{
                metadata: response?.metadata,
                onItemsPerPageChange: setItemsPerPage,
                onPageChange: setPage,
                pageSizeOptions: getPageSizeOptions(
                  response.metadata.totalItems,
                ),
                showPageSizeSelector: true,
              }}
              requestReports={response?.requestReports}
              setSortDescriptor={setSortDescriptor}
              sortDescriptor={sortDescriptor}
            />
          ) : null}
        </div>
      </FeaturePageLayout>
    </div>
  );
}
